import BaseView from '../../../js/base-view';

export default class CurrencySelector extends BaseView {
	init() {
		this.refs = {
			toggle: this.el.querySelector('[data-currency-selector="toggle"] span'),
			options: this.el.querySelector('[data-currency-selector="options"]'),
		};

		// channel=true : écoute sur document (FormAddress dispatch dessus).
		this.on('update-currency', this.onChange.bind(this), true);
	}

	onChange() {
		window.fetch(`${window.supt.restAPI.root}/supt/v1/currency`, {
			credentials: 'same-origin',
			headers: {
				'X-WP-Nonce': window.supt.restAPI.nonce,
			}
		})
			.then((res) => res.json())
			.then((res) => {
				this.refs.toggle.textContent = res.currency;
				this.refs.options.innerHTML = res.options;
			});
	}
}
